<template>

<div class="main store-profile">

	<div class="sub-header">
		<h1>Store Info / Profile</h1>
	</div>

	<div class="list-view">

		<div class="filters">
			<div class="button action" @click="saveClientProfile()">Save Profile</div>
		</div>

		<div class="detail no-sidebar no-sub-header">

			<loading v-if="loading"></loading>
			<div v-else class="two-one-columns">
				<!-- <contact-detail-form :clientId="clientDetail.client_id" :saveMessage="message" :contact="clientDetail" :emailRequired="true" :addressOnly="false" :hideDLInputs="true" :hideNotes="true" :hideControls="true" @update="updateContact" /> -->
				<div>
					<label>Company Name</label>
					<input type="text" v-model="clientDetail.company_name">
					<label>Doing Business As (DBA)</label>
					<input type="text" v-model="clientDetail.dba_name">
					<label-required label="Address Line 1" :condition="clientDetail.address_1"></label-required>
					<input type="text" v-model="clientDetail.address_1">
					<label>Address Line 2</label>
					<input type="text" v-model="clientDetail.address_2">
					<div class="two-columns">
						<div>
							<label-required label="City" :condition="clientDetail.city"></label-required>
							<input type="text" v-model="clientDetail.city">
						</div>
						<div class="two-columns">
							<label-required label="State" :condition="clientDetail.state || (clientDetail.country_code && clientDetail.country_code != 'US')"></label-required>
							<label-required label="Zip Code" :condition="clientDetail.zip_code"></label-required>
							<state-select type="text" :selectedState="clientDetail.state" :showApo="true" :showProvinces="true" placeHolder="Select..." @updateSelected="updateSelectedState"></state-select>
							<input type="text" v-model="clientDetail.zip_code">
						</div>
						<div>
							<label>County</label>
							<input type="text" v-model="clientDetail.county">
						</div>
					</div>
					<div class="two-columns">
						<div>
							<label>Phone Number</label>
							<input type="text" v-model="clientDetail.phone_number">
						</div>
						<div>
							<label>Email Address</label>
							<input type="text" v-model="clientDetail.email_address">
						</div>
					</div>

					<div class="two-one-columns">
						<div>
							<label>FFL Number</label>
							<input type="text" v-model="clientDetail.ffl_number">
						</div>
						<div>
							<label>FFL Expiration</label>
							<input type="date" v-model="clientDetail.ffl_date_expires">
						</div>
						<div>
							<label>State Permit Number</label>
							<input type="text" v-model="clientDetail.state_permit_number">
						</div>
					</div>

					<div class="two-one-columns">
						<div>
							<label>Time Zone</label>
							<select v-model="clientDetail.timezone_id">
								<option value=''>Select...</option>
								<option v-for="(timeZone, index) in timeZones" :value="timeZone.timezone_id">{{ timeZone.description }}</option>
							</select>

							<label>Primary Domain</label>
							<div class="input-with-tool-tip">
								<input type="text" disabled v-model="clientDetail.primary_domain" />
								<tool-tip left='-10' content='This is the main domain name under which your website will load. Contact support if you need to change your primary domain.'/>
							</div>
							<label>Courtesy Domain</label>
							<div class="input-with-tool-tip">
								<input type="text" disabled v-model="clientDetail.demo_domain" />
								<tool-tip left='-10' content='This is the domain name you were assigned to help you get started.'/>
							</div>
						</div>
					</div>
				</div>

				<div style="margin: 0 0 0 2em;">
					<div style="margin: 2em; text-align: center;">
						<img v-if="clientDetail.logo_src" :src="clientDetail.logo_src" />
						<div class="controls" style="margin: 2em 0 0 0;">
							<div class="button neutral spaced" @click="activateUploader()">{{ clientDetail.logo_src ? 'Replace' : 'Upload' }} Logo</div>
							<div v-if="clientDetail.logo_src" class="button neutral spaced" @click="showRemoveLogo = true">Remove Logo</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showImageUplaod">
		<div class="inner">
			<h2>Upload Logo Image</h2>
			<div class="content">
				<vue-dropzone @vdropzone-success="uploadSuccess" ref="imageDropzone" id="image_dropzone" :options="dropzoneOptions"></vue-dropzone>
			</div>
			<div class="controls">
				<div class="button cancel" @click="cancelImageUpload()">{{ imageUploadComplete ? 'Done With Upload' : 'Cancel' }}</div>
			</div>
		</div>
	</div>

	<div class="modal" v-if="showRemoveLogo">
		<div class="inner">
			<h2>Remove Logo Image</h2>
			<div class="content">
				If you remove your logo image, your website<br>will simply display your company name.
				<div v-if="message" class="message center">{{ message }}</div>
			</div>
			<div class="controls">
				<div class="button neutral spaced" @click="removeLogoImage()">Remove</div>
				<div class="button cancel spaced" @click="showRemoveLogo = false">Cancel</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>

</template>

<script>
import LabelRequired from '@/components/LabelRequired.vue'
import StateSelect from '@/components/StateSelect.vue'
import ToolTip from '@/components/ToolTip.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
    name: 'client-profile',
    components: {
        'label-required': LabelRequired,
        'state-select': StateSelect,
		'tool-tip': ToolTip,
        'vue-dropzone': vue2Dropzone
    },
    data() {
        return {
            loading: true,
            message: '',
			messageStatus: '',
			messageTimeout: 0,
			timeZones: [],
			clientDetail: {},
			showImageUplaod: false,
			showRemoveLogo: false,
			imageData: {},
			saving: false
        }
    },
    created() {
        this.getClientProfile()
    },
	computed: {
		dropzoneOptions() {
		    let re = new RegExp("dashboard_token=([^;]+)");
            let cookieToken = re.exec(document.cookie)
            let dashbordToken = (cookieToken != null) ? unescape(cookieToken[1]) : null
			return {
				url: this.getApiEndpoint + '?action=upload_client_logo',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 1.0,
				addRemoveLinks: true,
				thumbnailMethod: 'contain',
				dictDefaultMessage: 'Drop a logo image file here, or click to find an image...',
				params: {
					source: 'DASHBOARD',
					context: 'LOGO',
					fd_token: this.getDashboardToken
				}
			}
		}
	},
    methods: {
		getClientProfile() {
            this.apiCall({ destination: 'get_item_client_profile' }).then(obj => {
				this.timeZones = obj.timezones
                this.clientDetail = obj.client_detail
				this.loading = false
            }).catch(err => {
                console.log(err);
            })
		},
		updateSelectedState(state) {
			this.clientDetail.state = state
		},
		saveClientProfile() {
			if (this.saving) { return }
			this.saving = true
			this.messageStatus = ''
			this.message = 'Saving profile...'
            this.apiCall({ destination: 'save_item_client_profile', data: this.clientDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				this.message = obj.message
				this.messageTimeout = 1500
				// refresh the state client info
				this.apiCall({ destination: 'get_client' })
			}).catch(err => {
                console.log(err);
            })
		},
		activateUploader() {
			this.imageUploadComplete = false
			this.showImageUplaod = true
		},
		uploadSuccess(file, response) {
			var response = JSON.parse(response)
			this.clientDetail.logo_src = response.logo_src
			// force state to reload client info including new logo
            // this.apiCall({ destination: 'get_client' })
			this.$refs['imageDropzone'].removeAllFiles()
			this.imageUploadComplete = true
			this.showImageUplaod = false
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		cancelImageUpload() {
			this.showImageUplaod = false
			// reset the uploader image preview
			this.currentImageSrc = ''
		},
		removeLogoImage() {
			if (this.saving) { return }
			this.saving = true
			this.message = 'Removing logo...'
            this.apiCall({ destination: 'save_item_preference', data: { preference_code: 'LOGO_IMAGE', } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = 'Logo removed!'
					setTimeout(() => { 
						this.message = ''
						this.showRemoveLogo = false
						this.getClientProfile()
					}, 1500)
				} else {
					this.message = obj.message
				}
            }).catch(err => {
                console.log(err);
            })
		}
    }
}
</script>

<style lang="scss" scoped>
</style>
